export default __webpack_public_path__ + "static/media/exterior6.10348b9a.jpeg";